import { useQuery } from '@tanstack/react-query'
import { fetchKpis, fetchSignups, fetchActivity } from '@/lib/api/admin-stats'

export const statsKeys = {
  all: ['admin-stats'] as const,
  kpis: () => [...statsKeys.all, 'kpis'] as const,
  signups: (days: number) => [...statsKeys.all, 'signups', days] as const,
  activity: (limit: number) => [...statsKeys.all, 'activity', limit] as const,
}

export function useKpis() {
  return useQuery({
    queryKey: statsKeys.kpis(),
    queryFn: fetchKpis,
    staleTime: 60 * 1000,
  })
}

export function useSignups(days: number) {
  return useQuery({
    queryKey: statsKeys.signups(days),
    queryFn: () => fetchSignups(days),
    staleTime: 5 * 60 * 1000,
  })
}

export function useActivity(limit: number) {
  return useQuery({
    queryKey: statsKeys.activity(limit),
    queryFn: () => fetchActivity(limit),
    staleTime: 60 * 1000,
  })
}
